<script type="ts">
    import { stores } from "@nubolab-ffwd/svelte-fluent/src/internal/FluentProvider.svelte";
    import { Loading, Search, Button } from "carbon-components-svelte";
    import CatalogItem from "./catalog-item.svelte";
    import ArrowRight16 from "carbon-icons-svelte/lib/ArrowRight16";
    import ArrowLeft16 from "carbon-icons-svelte/lib/ArrowLeft16";
    import { getLocalizedValue } from "../helpers";

    export let inventory: {
        groups: InventoryGroup[],
        items: InventoryItem[]
    };
    export let onItemClick: (item: InventoryItem) => void;
    export let reset: number;

	const { getTranslation } = stores();

    let filteredInventory: InventoryItem[] = [];
    let selectedGroup: string = null;
    let search: string = '';

    let langCode = $getTranslation("language-code").value;

    $: selectedGroup = reset > 0 ? null : null;

    $: {
        filteredInventory = inventory?.items
            .filter(item => !item.hidden)
            .filter(item => (item.group ?? "other") === selectedGroup)
            .filter(item => item.tags?.some(t => t.includes(search)) || getLocalizedValue(item, "name", langCode).toLowerCase().indexOf(search.toLowerCase()) > -1);
    }
</script>

<div class="inventory">
    {#if !inventory}
    <Loading withOverlay={false} small />
    {:else if !selectedGroup}
    <div class="inventory__list">
        {#each inventory.groups as group}
        <Button kind="ghost" icon={ArrowRight16} on:click={() => selectedGroup = group.key}>{getLocalizedValue(group, "label", langCode)}</Button> 
        {/each}
    </div>
    {:else}
    <div class="search">
        <Button size="field" kind="ghost" icon={ArrowLeft16} iconDescription={$getTranslation("inventory-back").value} on:click={() => selectedGroup = null} /> 
        <Search light size="sm" bind:value={search} placeholder={$getTranslation("inventory-search").value} />
    </div>
    <div class="inventory__list">
        {#each filteredInventory as item} 
        <CatalogItem item={item} onClick={onItemClick} />
        {/each}
    </div>
    {/if}
</div>

<style type="text/scss">
    .inventory {
        height: 100%;
        display: flex;
        flex-direction: column;

        &__list {
            margin: 0 -1rem;
            height: 100%;
            flex-shrink: 1;
            flex-grow: 1;
            overflow-y: auto;
            overflow-x: hidden;
            padding-bottom: 1rem;

            :global(.bx--btn:not(.bx--btn--icon-only)) {
                width: 100%;
                max-width: none;
            }
        }
    }
    .search {
        display: flex;

        :global(.bx--search-input) {
            height: 2.5rem;
        }
    }
</style>